var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.127,
    y: 0.166,
    fill: "none",
    width: 39.33,
    height: 47.834
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 5.127,
    y: 0.166,
    width: 39.33,
    height: 47.834
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#E73537",
    points: "43.626,30.751 38.803,25.93 33.264,31.471 27.725,25.93  22.898,30.751 28.438,36.294 22.898,41.834 27.725,46.658 33.264,41.119 38.803,46.658 43.626,41.834 38.087,36.294  "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 3.625,
    width: 39.467,
    height: 48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#231F20",
    d: "M38.096,5.709L36.816,0C22.049,3.316,10.633,15.125,8.212,29.43 c-1.337-0.467-2.592-1.154-3.679-2.101c-0.188-0.154-0.446-0.171-0.655-0.046c-0.204,0.125-0.295,0.375-0.232,0.607 l5.395,19.705C9.104,47.82,9.295,47.975,9.524,48c0.017,0,0.03,0,0.046,0c0.216,0,0.404-0.125,0.5-0.32l8.659-18.513 c0.104-0.222,0.049-0.479-0.133-0.642c-0.172-0.154-0.434-0.18-0.646-0.063c-1.18,0.702-2.483,1.108-3.825,1.354 C16.362,18.1,25.846,8.471,38.096,5.709"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDown);
export default __webpack_public_path__ + "static/media/noDown.1b0a4a28109e004e0cd1b887bf7b4bf9.svg";
export { ForwardRef as ReactComponent };